export { default } from "./LoginApp";
